import React, { useEffect } from 'react';
import { ICheckbox } from './SaveInstrumentCheckbox.types';
import MobileSaveInstrumentCheckbox from './mobile/MobileSaveInstrumentCheckbox';
import DesktopSaveInstrumentCheckbox from './desktop/DesktopSaveInstrumentCheckbox';

const MIN_DESKTOP_WIDTH = 768;

function SaveInstrumentCheckbox({ classNamePrefix, value, onClick }: ICheckbox) {
  const [width, setWidth] = React.useState(window.innerWidth);

  const handleResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
  }, []);

  return (
    <>
      {width < MIN_DESKTOP_WIDTH ? (
        <MobileSaveInstrumentCheckbox classNamePrefix={classNamePrefix} value={value} onClick={onClick} />
      ) : (
        <DesktopSaveInstrumentCheckbox classNamePrefix={classNamePrefix} value={value} onClick={onClick} />
      )}
    </>
  );
}

export default SaveInstrumentCheckbox;
